var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":"","disabled":!_vm.tooltip_text},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_c('v-icon',{attrs:{"small":_vm.small,"color":_vm.color}},[_vm._v(_vm._s(_vm.icon_name))])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip_text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }